import { CartItem } from '../redux/slices/cartSlice';
import { OrderRequest } from '../redux/slices/orderSlice';
import { getCartItemName, getCartItemImage, formatModifiersForDisplay } from './cartUtils';

export const formatModifiersForAPI = (modifiers: any[]) => {
  return formatModifiersForDisplay(modifiers).map(modifier => ({
    modifier_name: modifier.options,
    modifier_price: modifier.price
  }));
};

export const calculateTotalModifierPrice = (modifiers: any[]): string => {
  const formattedModifiers = formatModifiersForDisplay(modifiers);
  const totalPrice = formattedModifiers.reduce((sum, modifier) => sum + modifier.price, 0);
  return totalPrice.toFixed(2);
};

export const transformCartToOrderRequest = (
  cartItems: CartItem[],
  formData: {
    name: string;
    phone: string;
    email: string;
    specialRequests: string;
  },
  restaurantId: string,
  payNow: boolean,
  grandTotal: number
): OrderRequest => {
  return {
    restaurant_id: restaurantId,
    name: formData.name,
    phone: formData.phone,
    email: formData.email,
    special_requests: formData.specialRequests,
    order_type: "web",
    delivery_type: "pickup",
    pay_now: payNow,
    ordered_items: cartItems.map(item => ({
      name: getCartItemName(item),
      quantity: item.quantity,
      itemPrice: item.item.price?.toString() || item.totalPrice.toString(),
      modifiers: formatModifiersForAPI(item.selected.modifiers),
      modifier_price: calculateTotalModifierPrice(item.selected.modifiers),
      spice_level: item.selected.spice?.label || "",
      image: getCartItemImage(item) || "",
      total_item_price: item.totalPrice.toString()
    })),
    grand_total: grandTotal.toFixed(2)
  };
};
